<template>
    <el-dialog
        :title="$t.__('listing.batchComponents.AddRecurringTermComponent.add_deadlines')"
        :modelValue="true"
        width="420"
        :beforeClose="close"
    >
        <label for="recAmount">{{
            $l10n.__("Nombre d'échéances à rajouter sur chaque abonnement")
        }}</label>
        <el-select id="recAmount" v-model="amount" filterable class="wp-10 mt-2 mb-4" name="amount">
            <el-option v-for="i in 20" :key="i" :label="i" :value="i" />
        </el-select>

        <CompassAlert
            :description="
                $t.__(
                    'listing.batchComponents.AddRecurringTermComponent.only_in_progress_subscriptions_will_be_modified',
                )
            "
            :showClose="false"
            class="mb-0"
            type="warning"
        />

        <template #footer>
            <span class="dialog-footer">
                <CompassButton
                    :label="$t.__('common.actions.cancel')"
                    type="secondary"
                    @click="close()"
                />
                <CompassButton
                    :label="$t.__('common.actions.confirm')"
                    type="primary"
                    :disabled="amount <= 0"
                    @click="save"
                />
            </span>
        </template>
    </el-dialog>
</template>

<script>
import { ListingEvent } from 'js/types/events';
export default {
    props: {
        rows: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            loading: true,
            amount: 0,
        };
    },
    methods: {
        save() {
            this.loading = true;
            this.$ajax.post(
                '/recurrings/recurring-term/add',
                {},
                { recIds: this.rows, recAmount: this.amount },
                (response) => {
                    Push.success(
                        this.$l10n.__(
                            'Votre ajout d’échéances est pris en compte, cela peut prendre quelques minutes.',
                        ),
                    );
                    this.close();
                    EventBus.emit(ListingEvent.REFRESH);
                },
                (error) => {
                    this.close();
                    Push.error(this.$l10n.__('Une erreur est survenue'));
                },
            );
        },
        close() {
            this.$emit('close');
        },
    },
};
</script>
